import { useEffect } from 'react';
import { useRealtime } from './RealtimeProvider';

/**
 * Entra na sala do board ao montar, sai ao desmontar e expõe `subscribe` para
 * os eventos do namespace `/boards`.
 *
 * Importante: inclua `socketEpoch` nas dependências do efeito que registra os
 * listeners. Ele muda a cada (re)conexão e garante que assinaturas feitas antes
 * do socket existir sejam refeitas.
 *
 * @param {string} boardId
 */
export const useBoardRealtime = (boardId) => {
  const { subscribeBoard, joinBoard, leaveBoard, isConnected, socketEpoch } = useRealtime();

  useEffect(() => {
    if (!boardId || !isConnected) return undefined;

    joinBoard(boardId);

    return () => leaveBoard(boardId);
  }, [boardId, isConnected, joinBoard, leaveBoard, socketEpoch]);

  return { subscribe: subscribeBoard, isConnected, socketEpoch };
};

export default useBoardRealtime;
